module.exports = __webpack_public_path__ + "img/gifYu.34bd89cf.gif";